<style lang="scss" src='./CartLateral.scss' scoped></style>
<template src="./CartLateral.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from "vuex";
  import ProductLateral from '@/components/productLateral/ProductLateral'
  export default {
    name: 'CartLateral',
    components: {
      ProductLateral,
    },
    data() {
      return {
        notes: '',
      };
    },
    computed: {
      ...mapState('CartStore', ['showCart', 'cartProducts']),
      ...mapState(['user','cart_notes']),

      showButtons(){
         return !['/payment/shipping','/payment/schedule','/payment/summary'].includes(this.$route.path);
      },

      showDeliveryPrice(){
        return this.cartProducts.delivery_method && this.cartProducts.delivery_method.type;
      },

      showDiscount(){
        return this.cartProducts.coupon && this.cartProducts.discount > 0;
      },
    },
    watch: {
      cart_notes: {
        handler: function (value) {
          this.notes = value;
        },
        deep: true,
      }
    },

    methods: {
      ...mapMutations(["setCartNotes"]),
      ...mapMutations('CartStore', ["setVisibility"]),
      fnFinishOrder() {
        let url = '';
        if (this.user.customer_id) {
          url = '/payment/shipping';
        } else {
          url = '/payment/signin?redirect=/payment/shipping';
        }
        if (this.$route.path != '/payment/signin') {
          this.$router.push(url);
        }
      },
      fnUpdateCartNotes() {
        this.setCartNotes(this.notes);
      },
    },
    beforeCreate() {},
    created() {
      this.notes = this.cart_notes;
    },
    mounted() {
    },
    beforeDestroy() {},
  };

</script>
